import { useQuery } from 'react-query';
import { api } from '#/apis';


const getScript = async () => {

    const { data } = await api.get('/scripts');

    return data;
};

export const useGetScript = (queryOptions = {}) => useQuery('script-get', () => getScript(queryOptions));

